import cookies from "js-cookie";

const TOKEN_NAME = "NEXT_LOCALE";

export const setLocaleCookie = (locale: string) => {
  cookies.set(TOKEN_NAME, locale);
};

export const removeLocaleCookie = () => cookies.remove(TOKEN_NAME);
